import type { ArticleBlockImageProps } from "./ShowArticleProps.d";

import React from 'react';


export function ImageBlock({ image, imageText }: ArticleBlockImageProps): React.JSX.Element {
	const {
		url,
		alt,
		caption,
	} = image;

	return (
		<div className="article article__image-container">
			<img src={url} alt={alt} />
			{caption || imageText && (<p>{caption || imageText}</p>)}
		</div>
	);
}
